<template>
  <div class="app-container">
    <div class="app-header">
      <div class="navbar-header"><a class="navbar-brand logo" href="#">在线Python编辑器</a></div>
      <a-dropdown>
        <a style="padding: 0 15px" class="ant-dropdown-link" @click.prevent>
          <a-icon type="file" />
          文件
        </a>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <a @click="openFile" href="javascript:;">打开文件</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="saveFile" href="javascript:;">保存文件</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <a-button class="header-btn" v-if="!isRunning" @click="runit" type="link"> <my-icon class="tool-icon" type="icon-bofang" />运行</a-button>
      <a-button class="header-btn" v-if="isRunning" @click="stopRun" type="link"><my-icon class="tool-icon" type="icon-tingzhi" />停止</a-button>
      <a-button class="header-btn" type="link" @click="highlightCode"><a-icon type="edit" />高亮</a-button>
      <a-button class="header-btn" type="link" @click="formatCode"><a-icon type="profile" />格式化</a-button>
    </div>
<!--      <a-layout-header style="padding: 0; height: 50px">-->
<!--        &lt;!&ndash; 控制按钮 &ndash;&gt;-->
<!--        <a-menu mode="horizontal" style="color: black; height: 100%">-->
<!--          <a-sub-menu>-->
<!--            <span slot="title" class="submenu-title-wrapper">-->
<!--              <a-icon type="file" />文件-->
<!--            </span>-->
<!--            <a-menu-item-group>-->
<!--              <a-menu-item key="setting:1">-->
<!--                <a type="primary" @click="openFile">打开</a>-->
<!--              </a-menu-item>-->
<!--              <a-menu-item key="setting:2">-->
<!--                <a type="primary" @click="saveFile">保存</a>-->
<!--              </a-menu-item>-->
<!--            </a-menu-item-group>-->
<!--          </a-sub-menu>-->

<!--          <a-menu-item>-->
<!--            <a-input-->
<!--              v-model="projectName"-->
<!--              placeholder="请输入项目名称"-->
<!--              style="width: 200px"-->
<!--            ></a-input>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item>-->
<!--            <a-button type="primary" @click="submitCode">提交</a-button>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item>-->
<!--            <a-button type="primary" @click="runit"><a-icon type="play-circle"/>运行</a-button>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item>-->
<!--            <a-button type="primary" @click="clear"><a-icon type="delete"/>清空</a-button>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item>-->
<!--            <a-button type="default" @click="toHome">返回</a-button>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item style="float: right" v-if="username">-->
<!--            <div class="right-menu">-->
<!--              <img :src="avatar" alt="" />-->
<!--              <span>{{ username }}</span>-->
<!--            </div>-->
<!--          </a-menu-item>-->
<!--        </a-menu>-->
        <input type="file" id="fileinput" style="display: none" />
<!--      </a-layout-header>-->
    <div class="app-content">
      <a-col style="height: 100%" :span="16">
        <JCodeEditor
          v-if="editorType == 'codemirror'"
          language="python"
          v-model="code"
          :fullScreen="true"
          placeholder="请输入代码"
          ref="codeEditor"
        />
        <AceEditor
          v-if="editorType == 'ace'"
          language="python"
          v-model="code"
          :height="'100%'"
          ref="codeEditor"
          id="editor"
        />
      </a-col>
      <a-col style="height: 100%" :span="8">
        <div style="width: 100%;height: 100%;padding: 0 10px 0 10px">
          <ul style="display: none" class="result-nav">
            <li class="active">输入输出</li>
          </ul>
          <div class="io-row">
            <a-col style="flex: 1;display: flex;flex-direction: column;" :span="24">
              <div>
                <span style="color: white;font-size: 24px;font-weight: bold">输入信息</span>
              </div>
              <div style="flex: 1">
                <textarea id="io-input" class="io-textarea"></textarea>
              </div>
            </a-col>
            <a-col style="flex: 2;flex-shrink:0;" :span="24">
              <div style="height: 36px">
                <span style="color: white;font-size: 24px;font-weight: bold">输出信息</span>
              </div>
              <div style="height: calc(100% - 36px)">
                <pre v-html="out" id="io-output" class="io-textarea"></pre>
              </div>
            </a-col>
          </div>
<!--          <a-tabs :activeKey="activeKey">-->
<!--            <a-tab-pane :key="1" tab="输入输出">-->

<!--            </a-tab-pane>-->
<!--          </a-tabs>-->
        </div>
      </a-col>
    </div>
      <a-drawer
        title="Command Line"
        placement="bottom"
        :visible="clVisible"
        @close="clVisible = false"
      >
        <pre v-html="out"></pre>
        <textarea style="width: 100%;border: none;outline: none;" id="ioTextArea"></textarea>
      </a-drawer>
      <a-modal
        :visible="true"
        :mask="false"
        wrapClassName="canvasParent"
        :footer="null"
        title="Canvas"
        :width="modalConfig.fullscreen?'100vw':modalConfig.width"
        dialogClass="canvasModal"
        :dialogStyle="{
          display:'block',
          visibility: canVisible?'visible':'hidden',
          overflow:'hidden',
          height: modalConfig.fullscreen?'100vh':modalConfig.height,
        }"
        @cancel="stopRun"
      >
        <div style="width: 500px;height: 500px">
          <div class="zoom-plugins">
            <a-icon style="cursor: pointer" @click="zoomInCanvas" type="zoom-in" />
            <a-icon style="cursor: pointer" @click="zoomOutCanvas" type="zoom-out" />
          </div>
          <div :style="{transform:'translate(calc(-50% + 0px), calc(-50% + 0px)) scale('+ canvasScale +', '+ canvasScale +')'}" id="mycanvas"></div>
        </div>
      </a-modal>
    <a-modal
      v-model="highlightCodeVisible"
      title="代码高亮"
      :bodyStyle="{
          paddingTop:'0',
        }"
      @ok="copyCode"
      v-if="highlightCodeVisible"
      okText="复制"
      cancelText="关闭"
    >
      <div style="display: flex;justify-content: end">
        <a-button @click="codeTheme = 'theme-one'" type="link">
          <span style="color: #ACC7DD">浅蓝色</span>
        </a-button>
        <a-button @click="codeTheme = 'theme-two'" type="link">
          <span style="color: #ACC7DD">蓝色</span>
        </a-button>
        <a-button @click="codeTheme = 'theme-three'" type="link">
          <span style="color: #D5DDA3">绿色</span>
        </a-button>
        <a-button @click="codeTheme = 'theme-four'" type="link">
          <span style="color: #F0CB9B">黄色</span>
        </a-button>
      </div>
      <div id="code-block" :class="codeTheme">
        <div v-for="(v,k) in highlightCodeArr" class="code-line-border">
          <span style="padding-right: 2px;margin-right: 2px;">{{ paddingZero(k + 1,2) }}</span>
          <span style="white-space: pre-wrap" v-html="v"></span>
        </div>
      </div>
    </a-modal>
    <div style="position: absolute;width: 500px;height: 500px;left: -500px;top: -500px;color: black" id="code-copy-area"></div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import JCodeEditor from "./JCodeEditor";
import AceEditor from "./AceEditor";
import Draggable from "draggable"
import "../python/skulpt.min.js";
import "../python/skulpt-stdlib.js";
import axios from "axios";
import hljs from 'highlight.js/lib/core'
import py from 'highlight.js/lib/languages/python'
import 'highlight.js/styles/atom-one-dark.css'
hljs.registerLanguage('python', py);
const Sk = window.Sk;

export default {
  name: "PythonEditor",
  components: {
    JCodeEditor,
    AceEditor,
  },
  props: {
    editorType: {
      type: String,
      default: "codemirror", //ace codemirror
    },
  },
  data() {
    return {
      code: "",
      out: "",
      projectName: "",
      username: "",
      avatar: "./static/avatar.png",
      clVisible: false,
      canVisible: false,
      activeKey: 1,
      isRunning: false,
      interrupt: false,
      canvasScale: 0.744,
      canvasScaleInit: 0.744,
      canvasScalePercent: 1,
      modalConfig: {
        width: '548px',
        height: '627px',
        fullscreen: false
      },
      highlightCodeVisible: false,
      highlightCodeArr: [],
      codeTheme: 'theme-one'
    };
  },
  mounted() {
    this.$nextTick(function (){
      var element = document.getElementsByClassName('canvasModal');
      new Draggable (element[0]);
    })
  },
  created() {
    var that = this;
    //载入网络项目
    var code = this.urlParam("code");
    if (code) {
      switch (code) {
        case 'P001':
          this.downloadFile("./static/secret.py");
          break
        case 'P103-1':
          this.downloadFile("./static/colorspiral.py");
          break
        case 'P103-2':
          this.downloadFile("./static/sakuratree.py");
          break
        case 'P103-3':
          this.downloadFile("./static/pinkpig.py");
          break
        case 'P103-4':
          this.downloadFile("./static/treasure.py");
          break
        case 'P110':
          this.downloadFile("./static/dog.py");
          break
        case 'P115-1':
          this.downloadFile("./static/shield.py");
          break
        case 'P115-2':
          this.downloadFile("./static/trafficlight.py");
          break
        case 'P106':
          this.downloadFile("./static/nstar.py");
          break
          // p201
          // p202
          // p203
          // p204
        case 'p201':
          this.downloadFile("./static/wuhuan.py");
          break
        case 'p202':
          this.downloadFile("./static/chisha.py");
          break
        case 'p203':
          this.downloadFile("./static/size.py");
          break
        case 'p204':
          this.downloadFile("./static/xuanzhuanstar.py");
          break
      }
    } else {
      this.downloadFile("./static/defaultPython.py");
    }
    //兼容载入项目事件
    window.document.addEventListener("loadPorject", function (e) {
      that.projectName = e.detail.projectName;
      that.downloadFile(e.detail.url);
    });
    this.code = ""
  },
  destroyed() {
  },
  methods: {
    runit() {
      var that = this;
      if(that.isRunning) {
        that.$message.info("程序正在运行中");
        return false
      }
      that.isRunning = true
      this.clear();
      Sk.pre = "output";
      Sk.inputfun = this.customInput
      Sk.interrupt = false
      Sk.configure({ output: that.terminalOut, read: that.builtinRead, setTimeout : this.overwriteSetTimeOut });
      Sk.TurtleGraphics = {width: 0, height: 0, target: 'mycanvas'}
      Sk.onAfterImport = function(library) {
        if(['classmethod','property','staticmethod','<stdin>'].indexOf(library) !== -1) {
          return false
        }
        switch (library){
          case 'turtle':
            that.canVisible = true
            break
          // default:
          //   that.clVisible = true
        }
      }
      var myPromise = Sk.misceval.asyncToPromise(function () {
        return Sk.importMainWithBody("<stdin>", false, that.getCode(), true);
      }, {
        "*": that.interruptHandler
      });
      console.log()
      myPromise.then(
        that.promiseSuccess,
        that.promiseFailed
      )
    },
    downloadFile(url) {
      var that = this;
      url = url + '?t=' + (new Date()).getTime()
      axios.get(url).then((res) => {
        that.setCode(res.data);
      });
    },
    openFile() {
      var that = this;
      var fileInput = document.getElementById("fileinput");
      fileInput.addEventListener("change", function (e) {
        const reader = new FileReader();
        const thisFileInput = e.target;
        reader.onload = function () {
          that.setCode(this.result);
          that.code = this.result;
        };
        reader.readAsText(thisFileInput.files[0]);
      });
      fileInput.click();
    },
    saveFile() {
      const code = this.$refs.codeEditor.getCodeContent()
      var n = new File(
        [code],
        (this.projectName ? this.projectName : "未命名") + ".py",
        {
          type: "text/plain;charset=utf-8",
        }
      );
      saveAs(n);
    },
    submitCode() {
      if (this.code == "") {
        this.$message.info("没有代码可以提交");
      }
      if (window.submitCode) {
        window.submitCode(this.projectName, this.getCode());
      }
    },
    setCode(code) {
      this.code = code;
      this.$refs.codeEditor.setCodeContent(code);
    },
    getCode() {
      this.code = this.$refs.codeEditor.getCodeContent();
      // this.code = this.code.replace(/\t/g,'    ')
      // this.code = this.code.replace(/\r/g, '\n')
      this.code = this.code.replaceAll("\u000D\u000A", "\n")
        .replaceAll("\u000B", "\n")
        .replaceAll("\u000C", "\n")
        .replaceAll("\u000D", "\n")
        .replaceAll("\u0085", "\n")
        .replaceAll("\u2028", "\n")
        .replaceAll("\u2029", "\n")
        .replaceAll('\u00A0', ' ')
      // let str = this.code;
      // let charArray = str.split("");
      //
      // for (let i = 0; i < charArray.length; i++) {
      //   console.log(charArray[i].charCodeAt());
      // }
      return this.code;
    },
    clear() {
      this.out = ""
      this.canvasScalePercent = 1
      this.canvasScale = this.canvasScaleInit * this.canvasScalePercent
      const ioTextArea = document.getElementById('io-input');
      ioTextArea.value = ""
      // document.getElementById("output").innerHTML = "";
      // document.getElementById("mycanvas").innerHTML = "";
    },
    terminalOut(v) {
      this.out = this.out + v
      // this.$set(this.out, this.out.length, text);
      // var mypre = document.getElementById("output");
      // mypre.innerHTML = mypre.innerHTML + v;
    },
    builtinRead(n) {
      console.log("Attempting file: " + Sk.ffi.remapToJs(n));
      if (
        Sk.builtinFiles === undefined ||
        Sk.builtinFiles.files[n] === undefined
      )
        throw `File not found: '${n}'`;
      return Sk.builtinFiles.files[n];
    },
    urlParam(name) {
      var results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(
        window.location.href
      );
      if (!results) {
        return 0;
      }
      return results[1] || 0;
    },
    toHome(){
      window.location.href='/account/center'
    },
    customInput(prompt) {
      const that = this
      return new Promise(resolve => {
        that.clVisible = false
        // 添加事件监听器以等待用户输入
        that.$nextTick(function() {
          const ioTextArea = document.getElementById('io-input');
          // 在这里添加处理回车键的逻辑
          ioTextArea.onkeydown = function (event){
            if (event.key === 'Enter') {
              event.preventDefault();  // 阻止默认行为（换行）
              const userInput =  ioTextArea.value ;
              that.terminalOut(userInput+ "\r\n")
              ioTextArea.value = ""
              resolve(userInput);
            }
          }
        })
      });
    },
    interruptHandler() {
      if (Sk.interrupt === true) {
        throw new Sk.builtin.KeyboardInterrupt('aborted execution');
      } else {
        return null; // should perform default action
      }
    },
    overwriteSetTimeOut(callback, delay) {
      const that = this
      const i = setInterval(function () {
        try{
          if(Sk.interrupt) {
            clearInterval(i)
            throw new Sk.builtin.KeyboardInterrupt('aborted execution');
          }
          if(delay < 0) {
            callback()
            clearInterval(i)
          }else{
            delay = delay - 1
          }
        }catch (error) {
          that.promiseFailed(error)
        }
      }, 1)
    },
    stopRun() {
      this.isRunning = false
      Sk.interrupt = true
      this.canVisible = false
    },
    promiseSuccess(mod) {
      const that = this
      that.$message.success("执行完毕");
      that.isRunning = false
      Sk.interrupt = false
      const ioTextArea = document.getElementById('io-input');
      ioTextArea.onkeydown = null
    },
    promiseFailed(err) {
      const that = this
      const errStr = err.toString();
      if(errStr.indexOf('KeyboardInterrupt') === -1) {
        that.$message.error(err.toString());
      }else{
        that.$message.error("程序结束");
      }
      that.isRunning = false
      Sk.interrupt = false
      const ioTextArea = document.getElementById('io-input');
      ioTextArea.onkeydown = null
    },
    zoomInCanvas() {
      if(this.canvasScalePercent >= 1.8) {
        return false
      }
      this.canvasScalePercent = this.canvasScalePercent + 0.1
      console.log(this.canvasScalePercent)
      this.canvasScale = this.canvasScaleInit * this.canvasScalePercent
    },
    zoomOutCanvas() {
      if(this.canvasScalePercent <= 0.4) {
        return false
      }
      this.canvasScalePercent = this.canvasScalePercent - 0.1
      console.log(this.canvasScalePercent)
      this.canvasScale = this.canvasScaleInit * this.canvasScalePercent
    },
    highlightCode() {
      const that = this
      this.highlightCodeVisible = true
      let code = this.getCode()
      code.replace(/_[\s]*\n/g,"_;\n")
      code = code.replace(/ /g, "　")
      code = code.replace(/\t/g, "　　　　")

      this.highlightCodeArr = hljs.highlight(code, {language: 'python'}).value.split("\n")
      this.highlightCodeArr.forEach(function(v,k) {
        that.highlightCodeArr[k] = v.replace(/　/g, '&nbsp;')
      })

      // let highlightedCode = ''
      // codeArr.forEach(function(v,k){
      //   let tmp =  '<div class="code-line-border" style="border-color: #ACC7DD"><span style="padding-right: 2px;margin-right: 2px;">'+ that.paddingZero(k + 1,2) +'　</span><span>' + v + '</span></div>'
      //   tmp = tmp.replace(/　/g, '&nbsp;')
      //   highlightedCode += tmp
      // })
      // console.log(highlightedCode)
      // this.highlightCodeArr = codeArr
    },
    paddingZero(num, length) {
      //这里用slice和substr均可
      return (Array(length).join("0") + num).slice(-length);
    },
    copyCode() {
      const contentDom = document.getElementById('code-block')
      var selection = window.getSelection()
      var range = document.createRange()
      var n = document.createElement('br')
      var n1 = document.createElement('br')
      var cloneNode = contentDom.cloneNode(true)
      cloneNode.append(n)
      cloneNode.append(n1)
      cloneNode.contenteditable = true
      document.getElementById('code-copy-area').append(cloneNode)
      range.selectNodeContents(cloneNode)
      selection.removeAllRanges()
      selection.addRange(range)
      setTimeout(() => {
        document.execCommand('Copy')
        document.getElementById('code-copy-area').removeChild(cloneNode)
      }, 50)
      // const input = document.createElement('textarea');
      // document.body.appendChild(input);
      // input.value = document.getElementById('code-block').innerText;
      // input.select();
      // if (document.execCommand('copy')) {
      //   console.log(document.execCommand('copy'));
      // }
      // document.body.removeChild(input);
      // const that = this
      // const dom = document.getElementById('code-block')
      // const content = this.getPasteHtml(dom,false)
      // console.log(content)
      // this.$copyText(content).then(
      //   e => {
      //     console.log('111111')
      //   },
      //   e => {
      //     console.log('复制失败：', e)
      //   }
      // )
    },
    formatCode() {
      const that = this
      const apiUrl = 'https://edu.kjt61.com/api/format_code';
      const params = {
        code: this.getCode(),
        language: 6
      };
// 将参数拼接到 URL
      const urlWithParams = new URL(apiUrl);
      Object.keys(params).forEach(key => urlWithParams.searchParams.append(key, params[key]));

      // 发起 POST 请求
      fetch(urlWithParams, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          if(data.status === 1) {
            that.$message.success('格式化成功');
            that.setCode(data.data)
          }else{
            that.$message.error(data.message);
          }
        })
        .catch(error => {

          console.error('Fetch error:', error);
        });
    },
    getPasteHtml(e, filterStyle, ignoreImg) {
      const clipboardData = e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData)
      let pasteText, pasteHtml
      if (clipboardData == null) {
        pasteText = window.clipboardData && window.clipboardData.getData('text')
      } else {
        pasteText = clipboardData.getData('text/plain')
        pasteHtml = clipboardData.getData('text/html')
      }
      if (!pasteHtml && pasteText) {
        pasteHtml = '<span>' + replaceHtmlSymbol(pasteText) + '</span>'
      }
      if (!pasteHtml) {
        return
      }

      // 过滤word中状态过来的无用字符
      const docSplitHtml = pasteHtml.split('</html>')
      if (docSplitHtml.length === 2) {
        pasteHtml = docSplitHtml[0]
      }
      // 过滤无用标签
      pasteHtml = pasteHtml.replace(/<\/?(meta|html|head|title|body|script|link|xml)( [\s\S]*?)*>/igm, '')
      // 去掉注释
      pasteHtml = pasteHtml.replace(/<!--.*?-->/mg, '')
      pasteHtml = pasteHtml.replace(/<!--?(\[)(\S|\s|[0-9])*?(\])--?>/mg, '')
      pasteHtml = pasteHtml.replace(/<o:p>[\n\r\s&nbsp;]*<\/o:p>/mg, '')
      pasteHtml = pasteHtml.replace(/<style(([\s\S])*?)<\/style>/mg, '')
      // 过滤 data-xxx href target 属性
      pasteHtml = pasteHtml.replace(/\s?data-.*?=('|")(\{?).+?(\}?)('|")/igm, '')

      if (ignoreImg) {
        // 忽略图片
        pasteHtml = pasteHtml.replace(/<img.+?>/igm, '')
      }

      if (filterStyle) {
        // 过滤样式
        pasteHtml = pasteHtml.replace(/\s?(style)=('|").*?('|")/igm, '')
        // 过滤别的标签
        pasteHtml = pasteHtml.replace(/<\/?(h1|h2|h3|h4|h5|p|div|ul|i|ol|li|strong|b|a|button|u|hr|pre|em|font|sup|SUB|table|tbody|td|th|tr|br|col)([\s\S]*?)>/igm, '')
        if (!/</g.test(pasteHtml)) {
          pasteHtml = pasteHtml.replace(/(\r\n|\r|\n)/g, '')
        }
      } else {
        // 保留样式
        pasteHtml = pasteHtml.replace(/\s?class=('|").*?('|")/igm, '')
      }
      return pasteHtml
    },
    editorZoomIn() {

    },
    editorZoomOut() {

    }
  },
};
</script>
<style scoped>
.app-container {
  width: 100%;
  height: 100vh;
  background-image: url(~@/assets/img/img.png);
  overflow: hidden;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #FFF;
}
.app-header{
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
}
.navbar-header a{
  color: #40B2BA !important;
  font-size: 28px;
  height: auto;
  line-height: initial;
  padding: 0 30px 0 15px;
}
.app-header::after{
  content: '';
  position: absolute;
  left: 15px;
  right: 15px;
  bottom: 0;
  border: 1px solid #203B4D;
  width: calc(100% - 30px);
}
.ant-dropdown-link{
  color: #FFF;
  font-size: 24px;
}
.ant-dropdown-link:hover{
  color: #40B2BA;
  background: none;
}
.header-btn{
  font-size: 24px;
  height: 36px;
  color: white
}
.header-btn:hover{
  color: #40B2BA;
  background: none;
}
.app-content{
  height: calc(100% - 90px - 30px);
  padding: 0 15px;
}
#editor {
  height: 100%;
}
.result-nav{
  display: flex;
  padding-left: 0;
}
.result-nav li {
  color: #40B2BA;
  font-size: 22px;
  margin-right: 30px;
  position: relative;
  cursor: pointer;
  list-style: none;
}
.result-nav li.active {
  color: #FFF;
}
.result-nav li.active::after {
  position: absolute;
  content: '';
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 1px;
  border-bottom: 2px solid #FFF;
}
.io-row {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.io-textarea{
  background: #121318;
  border: 2px solid #88FFD6;
  border-radius: 8px;
  font-size: 35px;
  line-height: 38px;
  color: white;
  height: 100%;
  width: 100%;
  resize: none;
  padding: 10px;
}
.io-textarea:focus{
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);
}
#io-output{
  margin: 0;
}
#mycanvas {
  width: 1400px;
  height: 1400px;
  /*transform: translate(calc(-50% + 0px), calc(-50% + 0px)) scale(0.744, 0.744);*/
  position: relative;
  top: 50%;
  left: 50%;
  border: none;
  outline: none;
  background-color: #fff;
}
.zoom-plugins{
  position: absolute;
  width: 70px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 4;
  right: 10px;
  top: 60px;
  font-size: 20px;
}
</style>
<style>
#editor>.ace_editor{
  border: 2px solid #88FFD6;
  border-radius: 8px;
}
#output {
  border: 1px solid black;
  height: 40vh;
  width: 100%;
  padding: 10px;
  margin: 10px 0;
}
.canvasParent{
  width: 0;
  height: 0;
  overflow: visible!important;
  left: calc((100% - 548px) / 2) !important;
}
.ant-modal-header{
  z-index: 4;
  position: relative;
}
.code-line-border {
  border-left: 3px solid;
  padding: 2px 5px!important;
  margin: 0!important;
  line-height: 14px;
  width: 100%;
  box-sizing: border-box;
}
.theme-one,.theme-two,.theme-three,.theme-four {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
}
.theme-one .code-line-border {
  border-color: #ACC7DD
}
.theme-one div:nth-of-type(odd){
  background-color: #E9F3F9;
  color: inherit;
}
.theme-one div:nth-of-type(even){
  background-color: #FFFFFF;
  color: inherit;
}

.theme-two .code-line-border {
  border-color: #ACC7DD
}
.theme-two div:nth-of-type(odd){
  background-color: #EFF2F9;
  color: inherit;
}
.theme-two div:nth-of-type(even){
  background-color: #FFFFFF;
  color: inherit;
}

.theme-three .code-line-border {
  border-color: #D5DDA3
}
.theme-three div:nth-of-type(odd){
  background-color: #F5F7EE;
  color: inherit;
}
.theme-three div:nth-of-type(even){
  background-color: #FFFFFF;
  color: inherit;
}

.theme-four .code-line-border {
  border-color: #F0CB9B
}
.theme-four div:nth-of-type(odd){
  background-color: #FCF4EA;
  color: inherit;
}
.theme-four div:nth-of-type(even){
  background-color: #FFFFFF;
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/PythonEditor.vue